import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class FlagsService {

    public msg_manutencao: string = 'Em Manutenção!'
    public flag_manutencao_qualidade_bl: boolean = false
    public disable_or_hidden_menu: any = [];

    public our_contact: string = '';

    public ota_live_app: any = {
        enabled: false,
        version: "",
        url: "",
        checksum: "",
        force_update: false
    }

    public update_app_by_version: any = {
        title: 'Nova versão disponível!',
        subtitle: 'Estamos constantemente aprimorando nosso aplicativo. Você precisa atualizar para continuar utilizando.',
        version: '0001',
        force_update: false,
        active: false
    };

}
